import { pluckNumber, pluck, toRaphaelColor, getFirstValue } from '@fusioncharts/core/src/lib';
import LineDataset from '@fusioncharts/charts/src/dataset/line';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import msStepLineAnimation from './index.animation';
let LINE = 'line',
  H = 'H',
  V = 'V',
  M = 'M',
  UNDEF;
addDep({
  name: 'stepLineAnimation',
  type: 'animationRule',
  extension: msStepLineAnimation
});
class MSStepLineDataset extends LineDataset {
  constructor () {
    super();
    // eslint-disable-next-line good-practices/no-function-dependency
    this.getPathArr = function () {
      var pathObj = this,
        pathArr = pathObj.pathArr,
        path2Arr = pathObj.path2Arr;

      if (pathArr.length || path2Arr.length) {
        return pathArr.concat(path2Arr);
      }
      return [];
    };
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'stepLine';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.drawverticaljoins = UNDEF;
    config.useforwardsteps = UNDEF;
  }
  _addLegend () {
    var dataset = this,
      conf = dataset.config,
      legend = dataset.getFromEnv('legend'),
      chartAttr = dataset.getFromEnv('chart-attrib'),
      drawAnchors = pluckNumber(conf.drawanchors, 1), // eslint-disable-line good-practices/no-single-usage-variable
      legendItem,
      JSONData = dataset.config.JSONData || {},
      config = { // eslint-disable-line good-practices/no-single-usage-variable
        enabled: conf.includeinlegend,
        type: LINE,
        /* In case of scatter (a child chartAPI of line),
        line is drawn in legend only when drawLine is set
        to true. */
        drawLine: pluck(conf.drawLine, true),
        anchorSide: drawAnchors ? conf.anchorsides : 0,
        label: getFirstValue(dataset.config.JSONData.seriesname),
        legendIconAlpha: pluckNumber(JSONData.legendiconalpha)
      };
    if (conf.includeinlegend) {
      legendItem = legend.getItem(dataset.config.legendItemId);
      if (!legendItem) {
        dataset.config.legendItemId = legend.createItem(dataset);
        legendItem = legend.getItem(dataset.config.legendItemId);
        dataset.addExtEventListener('fc-click', function () {
          legendItem.itemClickFn();
        }, legendItem);
      }
      legendItem.configure(config);
      legendItem.setStateCosmetics('default', {
        symbol: {
          fill: toRaphaelColor({
            color: conf.anchorbgcolor,
            alpha: conf.anchorbgalpha
          }),
          bgAlpha: pluckNumber(JSONData.legendiconbgalpha, JSONData.legendiconalpha, chartAttr.legendiconbgalpha, chartAttr.legendiconalpha, conf.anchorbgalpha),
          borderAlpha: pluckNumber(JSONData.legendiconborderalpha, JSONData.legendiconalpha, chartAttr.legendiconborderalpha, chartAttr.legendiconalpha, '100'),
          rawFillColor: conf.anchorbgcolor,
          rawStrokeColor: conf.anchorbordercolor,
          stroke: toRaphaelColor({
            color: conf.anchorbordercolor,
            alpha: '100'
          }),
          'stroke-width': conf.anchorborderthickness
        }
      });
      // check if dataset is initiallyhidden
      if (!dataset.getState('visible')) {
        legendItem.setLegendState('hidden');
      } else { // remove hidden state of legend item is dataset is not hidden
        legendItem.removeLegendState('hidden');
      }
    } else if (dataset.config.legendItemId) {
      legend.disposeItem(dataset.config.legendItemId);
    }
  }

  getLinePath (data, positions) {
    var dataset = this,
      conf = dataset.config,
      chartConfig = dataset.getFromEnv('chartConfig'),
      connectNullData = pluckNumber(chartConfig.connectnulldata), // eslint-disable-line good-practices/no-single-usage-variable
      obj = {},
      drawVerticalJoins = pluckNumber(conf.drawverticaljoins),
      halfStep = pluckNumber(chartConfig.stepatmiddle) ? dataset.getFromEnv('xAxis').getPVR() * 0.5 : 0,
      // Used for determining whether the last value was valid
      // Initially it is false
      lastValidValue = obj.lastValidValue || false,
      temp = obj.temp || [],
      temp2 = obj.temp2 || [], // eslint-disable-line good-practices/no-single-usage-variable
      pathArr = obj.pathArr || [],
      path2Arr = obj.path2Arr || [], // eslint-disable-line good-practices/no-single-usage-variable
      lastXPos,
      i,
      config,
      xPos,
      yPos,
      pointsJoined = obj.pointsJoined || 0,
      dataObj,
      setValue,
      startPos = (positions && positions.begin) || 0, // eslint-disable-line good-practices/no-single-usage-variable
      endPos = (positions && positions.end) || data.length, // eslint-disable-line good-practices/no-single-usage-variable
      step = chartConfig.viewPortConfig.step || 1, // eslint-disable-line good-practices/no-single-usage-variable
      dataWithRemovedPaths = [];
    // Added current dataStore to arr
    dataWithRemovedPaths = dataWithRemovedPaths.concat(data);

    for (i = startPos; i < endPos; i += step) {
      dataObj = dataWithRemovedPaths[i];
      if (!dataObj) {
        continue;
      }

      config = dataObj.config;
      setValue = config.setValue;

      // skip the data plot if isSkipped flag is set to false
      if (setValue === UNDEF || (config && config.isSkipped === true)) {
        config && (delete config.isSkipped);
        continue;
      }
      xPos = config._Px;
      yPos = config._Py;

      // create the path array
      // If the last value is valid
      if (setValue === null || setValue.isNull) {
        // If null data points are also to be connected
        if (!connectNullData) {
          temp = [];
          temp2 = [];
          lastValidValue = false;
        }
      } else {
        if (lastValidValue) {
          if (temp.length) {
            pathArr = pathArr.concat(temp);
            temp = [];
            pointsJoined++;
          }
          if (pluckNumber(conf.useforwardsteps)) {
            pathArr.push([H, xPos - halfStep]);
            if (drawVerticalJoins) {
              pathArr.push([V, yPos]);
            } else {
              pathArr.push([M, xPos - halfStep, yPos]);
            }
            if (halfStep) {
              pathArr.push([H, xPos]);
            }
          } else {
            if (drawVerticalJoins) {
              pathArr.push([V, yPos]);
            } else {
              pathArr.push([M, lastXPos, yPos]);
            }
            pathArr.push([H, xPos]);
            lastXPos = xPos;
          }
          // Push the upper x and y position to pathArr
          // pathArr.push([L, xPos, yPos]);
        } else {
          // Push the upper x and y positions of area plot to temp
          temp.push([M, xPos, yPos]);
          lastXPos = xPos;
          // No points are joined when starting a new path
          pointsJoined = 0;
          lastValidValue = true;
        }
      }
    }
    return {
      pathArr: pathArr,
      path2Arr: path2Arr,
      lastValidValue: lastValidValue,
      pointsJoined: pointsJoined,
      temp: temp,
      temp2: temp2,
      getPathArr: dataset.getPathArr
    };
  }
}
export default MSStepLineDataset;
